export * from './compare.js';
export * from './clone-from-fields.js';
export * from './map-object.js';
export * from './traverse.js';
export * from './merge.js';
export * from './keys-to-numbers.js';
export * from './pathed.js';
/**
 * Maps the keys of an object, returning a transformed object.
 * ```js
 * const input = {
 *  hello: `there`,
 *  chap: `chappie`
 * }
 *
 * mapObjectKeys(input, key => key.toUppercase());
 *
 * // Yields: { HELLO: `there`, CHAP: `chappie` }
 * ```
 * @param object
 * @param mapFunction
 * @returns
 */
export const mapObjectKeys = (object, mapFunction) => {
    const destinationObject = {};
    for (const entries of Object.entries(object)) {
        const key = mapFunction(entries[0]);
        destinationObject[key] = entries[1];
    }
    return destinationObject;
};
